import $ from 'jquery';
$(() => {
  // Sidebar
  const $sidebar = $('#account-sidebar');
  const $accountInfo = $('#account-sidebar .account-info');
  // const $menuContainer = $('#account-sidebar .menu-container');
  const $menuName = $('#account-sidebar .menu-name');

  function toggleSidebar(isOpen) {
    if (isOpen) {
      $sidebar.removeClass('w-10').addClass('w-64');
      setTimeout(() => {
        $accountInfo.removeClass('opacity-0 hidden').addClass('opacity-100');
        $menuName.removeClass('opacity-0 hidden').addClass('opacity-100');
      }, 150);
    } else {
      $accountInfo.removeClass('opacity-100').addClass('opacity-0');
      $menuName.removeClass('opacity-100').addClass('opacity-0');
      setTimeout(() => {
        $accountInfo.addClass('hidden');
        $menuName.addClass('hidden');
        $sidebar.removeClass('w-64').addClass('w-10');
      }, 150);
    }
  }
  if (window.innerWidth >= 1024) {
    $sidebar.on('mouseenter', function () {
      toggleSidebar(true);
    });

    $sidebar.on('mouseleave', function () {
      toggleSidebar(false);
    });
  }

  // Change password
  const passwordVisibility = {
    current: false,
    new: false,
    confirm: false,
  };
  const resetForm = $('.change-password-form-container form');

  $('.change-password-toggle').on('click', function () {
    resetForm.find('input').val('');
    $('#form-error').hide().text('');
    $('.change-password-form-container').toggle();
  });

  // Toggle visibility for current password
  $('#toggle-current-password').on('click', function (e) {
    togglePassword('current', this);
  });
  // Toggle visibility for new password
  $('#toggle-new-password').on('click', function (e) {
    togglePassword('new', this);
  });
  // Toggle visibility for confirm password
  $('#toggle-confirm-password').on('click', function (e) {
    togglePassword('confirm', this);
  });

  resetForm.on('submit', function (e) {
    e.preventDefault();
    const currentPassword = $('#current-password');
    const newPassword = $('#new-password');
    const confirmPassword = $('#confirm-password');
    const error = $('#form-error');
    error.hide().text('');

    if (!currentPassword.val()) {
      error
        .removeClass('text-green-800 bg-green-50')
        .addClass('text-red-800 bg-red-50')
        .text("Current password can't be empty")
        .show();
      return;
    }
    if (!newPassword.val()) {
      error
        .removeClass('text-green-800 bg-green-50')
        .addClass('text-red-800 bg-red-50')
        .text("New password can't be empty")
        .show();
      return;
    }
    if (!confirmPassword.val()) {
      error
        .removeClass('text-green-800 bg-green-50')
        .addClass('text-red-800 bg-red-50')
        .text("Confirm new password can't be empty")
        .show();
      return;
    }
    if (newPassword.val() !== confirmPassword.val()) {
      error
        .removeClass('text-green-800 bg-green-50')
        .addClass('text-red-800 bg-red-50')
        .text("New password and confirm password don't match")
        .show();
      return;
    }
    if (
      currentPassword.val() == newPassword.val() ||
      currentPassword.val() == confirmPassword.val()
    ) {
      error
        .removeClass('text-green-800 bg-green-50')
        .addClass('text-red-800 bg-red-50')
        .text('New password cannot be the same as old')
        .show();
      return;
    }

    $.ajax({
      type: 'POST',
      url: ajax_object.ajax_url,
      data: {
        action: 'customer_reset_password',
        currentPassword: currentPassword.val(),
        newPassword: newPassword.val(),
        confirmPassword: confirmPassword.val(),
      },
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          error
            .removeClass('text-red-800 bg-red-50')
            .addClass('text-green-800 bg-green-50')
            .text(response.data)
            .show();
          return;
        } else {
          error
            .removeClass('text-green-800 bg-green-50')
            .addClass('text-red-800 bg-red-50')
            .text(response.data)
            .show();
          return;
        }
      },
      error: function (error) {
        error
          .removeClass('text-green-800 bg-green-50')
          .addClass('text-red-800 bg-red-50')
          .text('Something went wrong, please try again')
          .show();
      },
    });
  });

  // Toggle password visibility
  function togglePassword(fieldKey, triggerElement) {
    const input = resetForm.find(`#${fieldKey}-password`)[0];
    const icon = $(triggerElement).find('.bi');
    passwordVisibility[fieldKey] = !passwordVisibility[fieldKey];

    if (passwordVisibility[fieldKey]) {
      input.type = 'text';
      icon.removeClass('bi-eye').addClass('bi-eye-slash');
    } else {
      input.type = 'password';
      icon.removeClass('bi-eye-slash').addClass('bi-eye');
    }
  }
});
